import Vue from 'vue';

Vue.component('stock-fifo-index', () =>
    import(/* webpackChunkName: 'stock-fifo-index' */ './stock-fifo-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/stock-fifo/index.js